import { useAuth } from "@/_core/hooks/useAuth";
import DashboardLayout from "@/components/DashboardLayout";
import { SuppliersTab } from "@/components/finance/SuppliersTab";
import { FinanceAccessDeniedState } from "@/components/finance/ui";
import { canAccessFinanceRoute } from "@/finance/financeNav";

export default function FinanceSuppliersView() {
  const { user } = useAuth();
  const allowed = Boolean(user && canAccessFinanceRoute("/accounting/suppliers", user.role));
  return <DashboardLayout>{allowed ? <SuppliersTab /> : <FinanceAccessDeniedState title="Acceso no disponible" message="Proveedores no está disponible para tu perfil." />}</DashboardLayout>;
}
